import atob from 'atob'
import btoa from 'btoa'
import { PossibleNodeTypes } from '~/graphql/types'

type PossibleTypes = PossibleNodeTypes | 'Listing'

export const generateGlobalId = (typeName: PossibleTypes, id: string | number): string => {
  return btoa(`${typeName}:${id}`)
}

const splitGlobalId = (id: string): string[] => {
  return atob(id).split(':')
}

export const decodeGlobalId = (id: string): string => {
  return splitGlobalId(id)[1]
}

export const getTypename = (id: string): string => {
  return splitGlobalId(id)[0]
}
